import CartesianChartResponse from "../cartesian/cartesian_chart_response"
import LineSeries from "./line_series"

export default class LineChartResponse extends CartesianChartResponse {
    constructor(attributes) {
        super(attributes)
        this.lines = (attributes.lines || []).map(line => new LineSeries(line))
    }

    linesFor({ xAxisLabel, yAxisLabel }) {
        return this.lines.filter(line => (
            line.matchesAxes(xAxisLabel, yAxisLabel)
        ))
    }
}
